import { createTheme } from "@mui/material";

import MuiButton from "web/Layout/MainHeader/Desktop/MBHeader/theme/button.modifier";
import MuiIconButton from "web/Layout/MainHeader/Desktop/MBHeader/theme/iconButton.modifier";
import MuiTypography from "web/Layout/MainHeader/Desktop/MBHeader/theme/typography.modifier";

import { themeOptions } from "web/theme/theme";

import typography from "./typographyModule";

const customTheme = () => {
  const { palette } = themeOptions();

  return createTheme({
    typography,
    components: { MuiButton, MuiIconButton, MuiTypography },
    palette,
  });
};

export default customTheme;
